<template>
    <div :class="{'with-border': with_border}" class="empty-response">
        <img alt="No data available" src="/img/svg/undraw_blank_canvas.svg" loading=lazy width="160" class="m-auto d-block">
        <p v-html="description"></p>
    </div>
</template>

<script>
export default {
    props: {
        description: {
            type: String,
            default: ''
        },
        with_border: {
            type: Boolean,
            default: true
        }
    }
}
</script>
